function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    this.updateViewportHeight();
    window.addEventListener('resize', this.updateViewportHeight);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
   
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);

      this.mainDetailsToggle.querySelector('summary').classList.remove("mr_move_close_button_drawer");
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  updateViewportHeight() {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
      if(summaryElement.getAttribute('aria-expanded')) summaryElement.classList.add("mr_move_close_button_drawer");
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


/* MR COMPONENTS */

class selectHoverImages extends HTMLElement {
  constructor() {
    super();
    this.bigImgsContainer = this.querySelector(".mr_img_change_js");
    this.nameDesignerContainer = this.querySelectorAll(".mr_js_name");
    this.blocks = this.querySelectorAll(".mr_img_lamps");
    this.imgDesigner = [];
    this.nameDesigner = [];

    this.blocks[0].classList.add("mr_img_lamps_inicial_active");

    if(this.blocks.length > 0) {
      this.blocks.forEach((elem) => {
        elem.addEventListener('mouseover', this.hoverFunction.bind(this));
        this.imgDesigner.push(elem.dataset.imagedesigner);
        this.nameDesigner.push(elem.dataset.namedesigner);
      });
    }
  }

  hoverFunction(event) {
    if(this.blocks[0].classList.contains("mr_img_lamps_inicial_active") && event.target.name !== "1") {
      this.blocks[0].classList.remove("mr_img_lamps_inicial_active");
    }
    this.bigImgsContainer.style.backgroundImage = `url(${this.imgDesigner[event.target.name - 1]})`
    this.nameDesignerContainer.forEach((element) => {
      element.innerHTML = `${this.nameDesigner[event.target.name - 1]}`
    });
    
  }


}

customElements.define('select-hover-images', selectHoverImages);

class SliderComponentWC extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.allB = this.querySelectorAll("[data-position]");
  
    if (!this.slider) return;


    this.sliderReady();
    

    this.slider.addEventListener('scroll', this.scrollSlider.bind(this));
    for(let i = 0; i < this.allB.length; i++) {
      this.allB[i].addEventListener('click', this.onButtonClick.bind(this));
    }
  }



  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = this.sliderItems[0].clientWidth * (event.target.name - 1);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  scrollSlider(event) {
    let wLi = this.sliderItems[0].clientWidth;
    let slideActual = event.target.scrollLeft / wLi;

    if(this.allB[Math.round(slideActual)].classList.contains("button_slider_disabled")) {
      for(let i = 0; i < this.allB.length; i++) {
        this.allB[i].classList.add("button_slider_disabled")
      }
    } 

    this.allB[Math.round(slideActual)].classList.remove("button_slider_disabled");
    this.allB[Math.round(slideActual)].classList.add("button_slider_active");
  }

  sliderReady() {
    if(this.allB.length > 0) {
      this.allB[0].classList.remove("button_slider_disabled");
      this.allB[0].classList.add("button_slider_active");
    }


    /* Time slider */
    if(this.slider && this.sliderItems.length > 0) {
    
      let widthLi = this.sliderItems[0].clientWidth;
      let time = this.slider.dataset.time * 1000;
      let totalWidth = (this.sliderItems.length -1 ) * widthLi;


      if(this.slider.dataset.boolean === "true") {
        setInterval(() => {
          let slideScrollPositionSlider;
          if(this.slider.scrollLeft <= totalWidth - widthLi) {
            slideScrollPositionSlider = this.slider.scrollLeft + widthLi;
            this.slider.scrollTo({
              left: slideScrollPositionSlider
            });
          } else {
            this.slider.scrollTo({
              left: 0
            });
          }
        }, time);
      }
    }
  }
}

customElements.define('slider-component-wc', SliderComponentWC);


class SliderComponentOnlyMobile extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.allB = this.querySelectorAll("[data-position]");
  
    if (!this.slider) return;


    this.sliderReady();
    

    this.slider.addEventListener('scroll', this.scrollSlider.bind(this));
    for(let i = 0; i < this.allB.length; i++) {
      this.allB[i].addEventListener('click', this.onButtonClick.bind(this));
    }
  }



  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = this.sliderItems[0].clientWidth * (event.target.name - 1);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  scrollSlider(event) {
    let wLi = this.sliderItems[0].clientWidth;
    let slideActual = event.target.scrollLeft / wLi;

    if(this.allB[Math.round(slideActual)].classList.contains("button_slider_disabled")) {
      for(let i = 0; i < this.allB.length; i++) {
        this.allB[i].classList.add("button_slider_disabled")
      }
    } 

    this.allB[Math.round(slideActual)].classList.remove("button_slider_disabled");
    this.allB[Math.round(slideActual)].classList.add("button_slider_active");
  }

  sliderReady() {
    if(this.allB) {
      this.allB[0].classList.remove("button_slider_disabled");
      this.allB[0].classList.add("button_slider_active");
    }


    /* Time slider */
    if(this.slider && this.sliderItems) {
    
      let widthLi = this.sliderItems[0].clientWidth;
      let time = this.slider.dataset.time * 1000;
      let totalWidth = (this.sliderItems.length -1 ) * widthLi;


      if(this.slider.dataset.boolean === "true") {
        setInterval(() => {
          let slideScrollPositionSlider;
          console.log(this.slider.scrollLeft)
          if(this.slider.scrollLeft <= totalWidth - widthLi) {
            slideScrollPositionSlider = this.slider.scrollLeft + widthLi;
            this.slider.scrollTo({
              left: slideScrollPositionSlider
            });
          } else {
            this.slider.scrollTo({
              left: 0
            });
          }
        }, time);
      }
    }
  }
}

customElements.define('slider-component-mobile', SliderComponentOnlyMobile);

class SliderComponentButton extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
  
    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    /* this.slider.addEventListener('scroll', this.scrollSlider.bind(this)); */
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));


 /*    this.sliderReady(); */
    
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  // onButtonClick(event) {
  //   event.preventDefault();
  //   const slideScrollPosition = this.sliderItems[0].clientWidth * (event.target.name - 1);
  //   this.slider.scrollTo({
  //     left: slideScrollPosition
  //   });
  // }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  // scrollSlider(event) {
  //   let wLi = this.sliderItems[0].clientWidth;
  //   let slideActual = event.target.scrollLeft / wLi;

  //   if(this.allB[Math.round(slideActual)].classList.contains("button_slider_disabled")) {
  //     for(let i = 0; i < this.allB.length; i++) {
  //       this.allB[i].classList.add("button_slider_disabled")
  //     }
  //   } 

  //   this.allB[Math.round(slideActual)].classList.remove("button_slider_disabled");
  //   this.allB[Math.round(slideActual)].classList.add("button_slider_active");
  // }

  sliderReady() {
    if(this.allB) {
      this.allB[0].classList.remove("button_slider_disabled");
      this.allB[0].classList.add("button_slider_active");
    }


    /* Time slider */
    if(this.slider && this.sliderItems) {
    
      let widthLi = this.sliderItems[0].clientWidth;
      let time = this.slider.dataset.time * 1000;
      let totalWidth = (this.sliderItems.length -1 ) * widthLi;


      if(this.slider.dataset.boolean === "true") {
        setInterval(() => {
          let slideScrollPositionSlider;
          console.log(this.slider.scrollLeft)
          if(this.slider.scrollLeft <= totalWidth - widthLi) {
            slideScrollPositionSlider = this.slider.scrollLeft + widthLi;
            this.slider.scrollTo({
              left: slideScrollPositionSlider
            });
          } else {
            this.slider.scrollTo({
              left: 0
            });
          }
        }, time);
      }
    }
  }
}

customElements.define('slider-component-button', SliderComponentButton);





class effectAppear extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".mr_style_effect");

    this.onloadEffect();
  }

  onloadEffect() {
    setTimeout(() => {
      this.image.style.height = "100%";
      this.image.style.opacity = "1";
      
    }, 1000);
    
  }
}

customElements.define('effect-appear', effectAppear);


/* check privacy */
class CheckTermsNewsLetter extends HTMLElement {
  constructor() {
    super();
    this.check = this.querySelector(".mr_check_terms_button"); // input checkbox
    this.subscribe = this.querySelector("#mr_button_newsletter"); // button submit
    this.error = this.querySelector(".mr_error_msg_terms"); // error msg

    this.subscribe.addEventListener("click", (event) => {
 
      if(this.check.checked && this.subscribe.hasAttribute("disabled")) {
        this.subscribe.removeAttribute("disabled");
        if(this.error.innerHTML) {
          this.error.innerHTML = "";
        }
      } else if(!this.check.checked && !this.subscribe.hasAttribute("disabled")) {
        this.subscribe.setAttribute("disabled", true);
        this.error.innerHTML = this.error.dataset.msg;
        this.error.classList.remove("hidden");
      }
    });

    this.check.addEventListener("click", (event) => {
      if(this.check.checked && this.subscribe.hasAttribute("disabled")) {
        this.subscribe.removeAttribute("disabled");
        if(this.error.innerHTML) {
          this.error.innerHTML = "";
        }
      } else if(!this.check.checked && !this.subscribe.hasAttribute("disabled")) {
        this.subscribe.setAttribute("disabled", true);
        this.error.innerHTML = this.error.dataset.msg;
        this.error.classList.remove("hidden");
      }
    });

  }
}

customElements.define('check-terms-newsletter', CheckTermsNewsLetter);

/* menus to dropdown in footer */
class BoxDropdowFooter extends HTMLElement {
  constructor() {
      super();
      this.open = this.querySelector(".plus-dropdown-footer-mr");
      this.sibling = this.querySelector("ul");
      this.open.addEventListener("click", (event) => {
        if(this.open.classList.contains("close-dropdown-footer-mr")) {
          this.open.classList.remove("close-dropdown-footer-mr");
          this.sibling.classList.add("hide-list-footer-mr");
        }
        else {
          this.open.classList.add("close-dropdown-footer-mr");
          this.sibling.classList.remove("hide-list-footer-mr");
        }
      });
  }
}

customElements.define('box-dropdow-footer', BoxDropdowFooter);


class ClickHoverMR extends HTMLElement {
  constructor() {
    super();
    this.completeDiv = this;
    this.containerContent = this.querySelector(".mr_container_of_container_content_img");
    this.divNoClick = this.querySelector(".mr_container_content_img");
    this.divClick = this.querySelector(".mr_container_content_img_hover");
    this.button = this.querySelector(".mr_button_text_text");
    this.buttonClose = this.querySelector(".mr_js_button_close");

 

    this.button.addEventListener('click', this.clickButton.bind(this))
    this.buttonClose.addEventListener('click', this.closeButton.bind(this))
  }

  clickButton(event) {
    event.preventDefault();
    this.completeDiv.classList.add("mr_img_with_text_hidden");
    this.completeDiv.classList.remove("mr_img_with_text");
    this.containerContent.classList.add("mr_container_of_container_content_img_hover");
    this.containerContent.classList.remove("mr_container_of_container_content_img");
    this.divNoClick.classList.add("hidden");
    this.divClick.classList.remove("hidden");
  }

  closeButton(event) {
    event.preventDefault();
    this.completeDiv.classList.remove("mr_img_with_text_hidden");
    this.completeDiv.classList.add("mr_img_with_text");
    this.containerContent.classList.remove("mr_container_of_container_content_img_hover");
    this.containerContent.classList.add("mr_container_of_container_content_img");
    this.divNoClick.classList.remove("hidden");
    this.divClick.classList.add("hidden");
  }
}

customElements.define('click-hover-mr', ClickHoverMR);